import { C_REALESTATE_TYPES } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { uniq } from "lodash";
import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareFeaturesToServer = (body: IPropertyForm) => {
  const allFeatures = [
    ...body.features_property.map(x => x.value),
    ...body.characteristics_frames_property.map(x => x.value),
    ...body.characteristics_closets_property.map(x => x.value),
    ...body.characteristics_door_property.map(x => x.value),
    ...body.characteristics_roof_property.map(x => x.value),
    ...body.characteristics_windows_property.map(x => x.value),
    ...body.characteristics_cabinets_property.map(x => x.value),
    ...body.characteristics_floors_property.map(x => x.value),
    ...body.characteristics_type_house_property.map(x => x.value),
    ...body.characteristics_roof_form_property.map(x => x.value),
    ...body.uses_property.map(x => x.value),
    ...body.position_property.map(x => x.value)
  ];
  if (HCheckArray(body.is_study_property) && HCheckArray(body.type_property)) {
    if (
      body.is_study_property[0].id == C_YES_AND_NOT.YES.id &&
      body.type_property[0].value == C_REALESTATE_TYPES.APARTMENT.value
    ) {
      allFeatures.push(28);
    }
  }

  return uniq(allFeatures).filter(
    x => typeof x !== "undefined" && x !== null && x !== ""
  );
};
export default prepareFeaturesToServer;
